export default {
    'HomePage.welcome':'welcome',//欢迎您
    'FirstPage.Home': 'go home',
    'HomePage.password': 'change password',               //修改密码
    'HomePage.logout': 'logout',                          //注销
    'HomePage.title': 'spare parts catalog',//备件目录
    'HomePage.backend': 'backend',                        //进入后台
    'HomePage.DF': 'eπ after sales technical service platform',        //东风风神售后技术服务平台
    // 'HomePage.foot':'Zhejiang Geely Holding Group Co., Ltd. All Rights Reserved', //武汉宏承天佑汽车技术服务有限公司
    'news.welcome': 'Hello, welcome to eπ after-sales technical service platform',   //您好，欢迎来到奕派科技售后技术服务平台
    'yjNews.welcome': 'Hello, welcome to the Yijing Spare Parts Catalog System',
    'news.popTitle': 'Message',//消息通知

    //登录表单验证
    'loginPage.usrName': 'Login Account',//用户名
    'loginPage.usrNameInfo': 'Please input login account',//用户名不能为空，请输入用户名！
    'loginPage.passWord': 'Password',//密码
    'loginPage.passWordInfo': 'Password can not be empty!',//密码不能为空，请输入密码！
    'loginPage.code': 'Security Code',//验证码
    'loginPage.codeInfo': 'Please input security code',//请输入验证码
    'loginPage.codeWrong': 'Wrong Security Code',//验证码错误
    'loginPage.browse': 'For better user experience,please use ',//为了更好的使用体验，请使用
    'loginPage.login': 'login',//登录

    //强制修改密码
    'changePassword.oldPassword': 'Original Password',//旧密码
    'changePassword.newPassword': 'New Password',//新密码
    'changePassword.againPassword': 'Input password again',//再次输入密码
    'changePassword.fillPassword': 'Please fill in password',//请填写密码
    'changePassword.twicePassword': 'The two passwords you entered did not match',//两次输入的密码不一致,
    'forceChangePassword.title': 'Please update your password',//请更新密码
    'forceChangePassword.sameAsTheOld': 'Can\'t be the same as the old password, please re-enter',//不能与旧密码一样，请重新输入
    'forceChangePassword.moreCharacters': 'Use 8 to 16 characters (combinations of letters, upper and lower case, numbers and symbols)',//使用8个或更多字符(字母大小写、数字和符号的组合)
    'forceChangePassword.success': 'Successful password modification',//密码修改成功
    'forceChangePassword.fail':'Initial password input error, please re-enter',//初始密码输入错误，请重新输入
    'forceChangePassword.timeReminder': 'Your account has {day} days expired. Please change your password.',//您的账号还有{day}天过期，请修改密码

    //服务站操作
     'StationModify.Define': 'Comfirm',//确定
    //购物车单条删除
    'shopping.oneDeleteTitle': 'Notes', //提示
    'shopping.msg': 'Please select data first', //请先选择数据

    //侧边栏
    'sidebar.carInquiry':'Car Inquiry',//车系查询
    // 'sidebar.news':'News',//新闻
    'sidebar.order':'Order', //购物车
    'sidebar.carModel':'Car model',//备件查询
    'sidebar.carInquiryChange':'Spare part change inquiry', //备件变更查询
    // 'sidebar.onlineQestion':'Online Qestion', //答疑平台
    'sidebar.knowledgeBase':'folder',//文件夹
    // 'sidebar.orderHistory':'Order History',//订单历史

    //按钮及公共
    'search': 'Search',                               //查询
    'reset': 'Reset',                                 //重置
    'operation': 'Operation',                                 //操作
    'download': 'Download',                                 //下载
    'warnReset': 'Reset Successfully',                  //重置成功
    'all':'all',          //全部

    //车系查询
    'carInquiry.searchInput':'VIN',//VIN码
    'carInquiry.notice': 'Notice',//通知
    'carInquiry.index': 'index',//索引
    'carInquiry.announcement': 'Bulletin',//公告
    'ConfigureQuery.ApplicableModels': 'Applicable models',//适用车型

    //新闻
    'news.tableNo':'No.',//序号
    'news.tableTitle':'Title',//标题
    'news.tableCategory':'Category',//所属类别
    'news.tableAffiliation':'Affiliation',//所属栏目
    'news.tableSubmitTime':'Submit Time',//发布时间
    'news.tableFounder':'Founder',//创建人

    //知识库
    'knowledgeBase.fileName':'File Name', //文件名称
    'knowledgeBase.uploadUser':'Upload User', //上传人
    'knowledgeBase.uploadTime':'Upload Time',//上传时间
    'knowledgeBase.chineseName':'Chinese Name',//中文名称

    //答疑中心
    'answerSubject.add': 'Add',              //新增
    'answerSubject.addTheme': 'Subject',    //主题
    'answerSubject.addAMG': 'Car Model',                //车系
    'answerSubject.VIN': 'VIN',//vin码
    'answerSubject.tableQuestioner': 'User',                   //提问人
    'answerSubject.tableQuestionTime': 'Submit time',          //提问时间
    'answerSubject.tableAMG': 'Car Model',                        //车系
    'answerSubject.AuditStatus': 'In Approval Processing',//审核状态
    'answerSubject.tableAdoptState': 'Status',            //采纳状态
    'answerSubject.adopted': 'Adopted',//已采纳
    'answerSubject.unAdopted': 'Not Adopted',//未采纳
    'answerSubject.Audited': 'Approved',//已审核
    'answerSubject.Unaudited': 'Not Approved',//未审核
    'answerSubject.productionDate': 'Production Date',//生产日期
    'answerSubject.engineNumber': 'Engine Number',//发动机号
    'answerSubject.transmissionNumber': 'Transmission Number',//变速器号
    'answerSubject.edit': 'Edit',//编辑
    'answerSubject.enterEngine': 'Complete engine number must be filled in.',//必须填写完整的发动机号
    'answerSubject.enterTransmission': 'Complete transmission number must be filled in.',//必须填写完整的变速器号

    'answerSubject.type': 'Type',//问题类型
    'answerSubject.mainGroupCode': 'Main group',//主组
    'answerSubject.groupCode': 'Grouping',//分组
    'answerSubject.assess': 'Evaluate',//评价
    'answerSubject.satisfied': 'Satisfied',//满意
    'answerSubject.noSatisfied': 'Dissatisfied',//不满意
    'answerSubject.setAssess': 'Please evaluate',//请评价
    'answerSubject.replyStatus': 'Recovery state',//回复状态
    'answerSubject.reply': 'Reply',//回复
    'answerSubject.noReply': 'Unanswered',//未回复
    'answerSubject.mine': 'Mine',//我的
    'answerSubject.vin': 'Please select VIN code',//请选择VIN码
    'answerSubject.inputMainGroupCode': 'Please enter the main group number',//请输入主组号
    'answerSubject.inputContactName': 'Please enter contact',//请输入联系人
    'answerSubject.inputContactNumber': 'Please enter the contact number',//请输入联系电话
    'answerSubject.newEngineNumber': 'Engine stamp No.',//发动机钢印号
    'answerSubject.contactName': 'Contacts',//联系人
    'answerSubject.emergencyLevel': 'Emergency level',//紧急程度
    'answerSubject.askQuestion': 'ask question',//紧急程度
    'answerSubject.serviceStation': 'service station name',//服务站名称
    'answerSubject.newTransmission': 'Transmission No.',//变速器钢印号
    'answerSubject.contactNumber': 'Contact number',//联系电话
    'answerSubject.email': 'email',//邮箱
    'answerSubject.TKSReply': 'Thank you for your comments on this reply',//感谢您对本次回复作出相应评价
    'answerSubject.inputAssess': 'Please enter the evaluation reason',//请输入评价原因
    'answerSubject.emptyEdit': 'Edit content cannot be empty',//编辑内容不能为空
    'answerSubject.selfMadeDate':'selfMadeDate',//生产日期
    'answerSubject.carMaterialName':'carMaterialName',//整车描述

    //答疑平台新增
    'answer.addVerificationTheme': 'Please Input Subject',      //请输入主题
    'answer.type': 'Please select question type',//请选择问题类型
    'answer.emergencyLevel': 'Please select urgency',//请选择紧急程度
    'answer.email': 'please enter your email',//请填写邮箱
    'answer.groupCode': 'Please select group',//请选择分组
    'answer.newTransmission': 'Please fill in the contact information',//请填写联系方式
    'answer.addVerificationMsg': 'Blank Forbidden',            //不能输入空格
    'answer.addVerificationAMG': 'Please fill in model',        //请输入车系
    'answer.addVerificationAMGInput': 'Select',          //请选择
    'answer.addDealer': 'Dealer',                                //经销商
    'answer.addVerificationDealer': 'Please enter the dealer',  //请输入经销商
    'answer.addPosition': 'Assembly Location',                    //装配位置
    'answer.addVerificationPosition': 'Please give assembly location ',//请输入装配位置
    'answer.addUpload': 'Attachment',                       //上传附件
    'answer.upload': 'Attachment',                       //附件
    'answer.addSubjectContent': 'Please give the subject',//请输入主题内容
    'answer.addSuccessfully': 'Add successfully and wait for approval',//主题新增成功，等待审核
    'answer.FileUploadSucceeded': 'The file uploaded with success',  //文件上传成功
    'answer.FileUploadFailed': 'The file uploaded with failure',  //文件上传失败
    'answer.addFiles': 'Please add files',  //请添加文件
    'answer.twoEmergent': 'Two emergencies have been raised this month',  //本月已经提起2次紧急

    //答疑平台主题
    'answerReply.goBack': 'Go Back',//返回
    'answerReply.national': 'Market',//国家大区
    'answerReply.dealer': 'User',//经销商
    'answerReply.AMG': 'Car Model',//车系
    'answerReply.position': 'Assembly Location',//装配位置
    'answerReply.poster': 'User',//发帖人
    'answerReply.postTime': 'Submit Time',//发帖时间
    'answerReply.return': 'Back',//返回
    'answerReply.Download': 'Download',//下载附件
    'answerReply.Reply': 'Reply',//回复
    'answerReply.adoption': 'Adopt',//采纳
    'answerReply.define': 'Sure',//确定
    'answerReply.cancel': 'Cancel',//取消
    'answerReply.content': 'Please Input...',//请输入内容...
    'answerReply.collapseReply': 'Withdraw Reply',//收起回复
    'answerReply.themeAdoption': 'It is adopted and can not reply any more.',//主题已被采纳，不能再回复、采纳
    'answerReply.replyInfo': 'Reply Information',//请先输入回复内容
    'answerReply.replySuccess': 'Reply Successfully',//回复成功
    'answerReply.addUpload': 'Upload File',//上传附件
    'answerReply.viewAll': 'See all {length} replies', //查看全部{length}条回复
    'answerReply.release': 'Release', //发布

    //配置查询模块
    'ConfigureQuery.enterCode': 'Please Input VIN', //请输入VIN码
    'ConfigureQuery.querying': 'Searching Process', //正在查询
    'ConfigureQuery.noExist': 'Vin is not exist', //vin码不存在
    'ConfigureQuery.searchBtn': 'Search', //搜索
    'ConfigureQuery.Annual': 'Year', //年款
    'ConfigureQuery.Displacement': 'Displacement', //排量
    'ConfigureQuery.Configuration': 'Configuraion', //配置
    'ConfigureQuery.color': 'Interior Trim Color', //内饰颜色
    'ConfigureQuery.TransmissionType': 'Transmission', //变速器类型
    'ConfigureQuery.DriveMode': 'Drive Mode', //驱动方式
    'ConfigureQuery.EmissionStandards': 'Emission Standards', //排放标准
    'ConfigureQuery.VINCode': 'VIN Code', //VIN码
    'ConfigureQuery.reset': 'Reset',//重置
    'ConfigureQuery.VINDecide': 'Please enter the correct VIN code',//请重新输入正确的VIN码

    //配置查询详情页面
    'ConfigureQuery.Group': 'Subgroup No.', //组号
    'ConfigureQuery.SectionNo': 'Section No.', //节号
    'ConfigureQuery.ReferenceNo': 'Reference No.',//索引号
    'ConfigureQuery.name': 'Name', //名称
    'ConfigureQuery.Remark': 'Notes', //备注
    'ConfigureQuery.Label': 'NO.',//标号
    'ConfigureQuery.SparePartNumber': 'Spare Parts No.',//备件编号
    'ConfigureQuery.materialCode': 'Material No.',//物料号
    'ConfigureQuery.SparePartName': 'Spare Parts Name',//备件名称
    'ConfigureQuery.Location': 'Location',//位置
    'ConfigureQuery.VINNumber': 'VIN number',//VIN号
    'ConfigureQuery.Quantity': 'QTY',//数量
    'ConfigureQuery.letter': 'Rail identification',//轨件标识
    'ConfigureQuery.DateOfActivation': 'Start Date',//启用日期
    'ConfigureQuery.operate': 'Operaion',//操作
    'ConfigureQuery.seeDetails': 'Details',//查看详情
    'ConfigureQuery.AddOrder': 'Order',//添加订单
    'ConfigureQuery.imageDisplay': 'Picture',//图片展示
    'ConfigureQuery.BreakpointInformation': 'Nodes Information',//断点信息
    'ConfigureQuery.ReplacementRelationship': 'Replacement',//替换关系
    'ConfigureQuery.orderNumber': 'Number',//数量
    'ShoppingModal.title': 'Add',//添加

    //备件详情ConfigureSpareModal
    'ConfigureSpareModal.SpareDetail': 'Spare Parts Informaion',//备件详情
    'ConfigureSpareModal.SparePicture': 'Picture',//备件图片
    'ConfigureSpareModal.SupplierNo': 'Supplier No',//供应商编号

    //备件技术属性
    'ConfigureSpareModal.TechnicalAttribute': 'Spare Parts Informaion',//备件技术属性

    //备件目录属性
    'ConfigureSpareModal.DirectoryAttribute': 'Spare parts catalog attribute',//备件目录属性
    'ConfigureSpareModal.SparePartName': 'Spare Parts Name',//备件名称
    'ConfigureSpareModal.Remarks': 'Notes',//备注

    //左边
    'ConfigureSpareModal.SpecificationModel': 'Type',//规格型号
    'ConfigureSpareModal.volume': 'volume',//体积
    'ConfigureSpareModal.unit': 'Basic unit of measure',//基本计量单位
    'ConfigureSpareModal.Regulations': 'Regulations',//法规件
    'ConfigureSpareModal.colour': 'colour',//颜色
    'ConfigureSpareModal.LifeCycle': 'Life cycle (month)',//生命周期(月)
    'ConfigureSpareModal.PartSource': 'Spare part source',//备件来源
    'ConfigureSpareModal.partStatus': 'Spare part status',//备件状态
    'ConfigureSpareModal.supplierCode': 'Vendor Code',//供应商代码
    'ConfigureSpareModal.MaterialType': 'Material type',//物料类型
    'ConfigureSpareModal.CustomsCode': 'Customs code',//海关编码
    'ConfigureSpareModal.CIQText': 'CIQ text',//CIQ文本
    'ConfigureSpareModal.ProductGroup': 'Product Group',//产品组
    'ConfigureSpareModal.EntryTime': 'Entry Time',//录入时间
    'ConfigureSpareModal.InputStartStopTime': 'Input start-stop time',//录入起止时间
    'ConfigureSpareModal.Manufacturer': 'Manufacturer',//生产商
    //右边
    'ConfigureSpareModal.Material': 'Material',//材质
    'ConfigureSpareModal.weight': 'weight',//重量
    'ConfigureSpareModal.WeightUnit': 'Weight unit',//重量单位
    'ConfigureSpareModal.DesignLife': 'Design life (months)',//设计寿命(月)
    'ConfigureSpareModal.skillsRequirement': 'skills requirement',//技术要求
    'ConfigureSpareModal.DataSources': 'Data Sources',//数据来源
    'ConfigureSpareModal.SparePartType': 'Spare part type',//备件类型
    'ConfigureSpareModal.supplier': 'supplier',//供应商
    'ConfigureSpareModal.IndustryType': 'Industry type',//行业类型
    'ConfigureSpareModal.OldNumber': 'Old material number',//旧物料号
    'ConfigureSpareModal.CommodityInspectionMark': 'Commodity inspection mark',//商检标识
    'ConfigureSpareModal.ChineseName': 'Customs Chinese name',//报关中文品名
    'ConfigureSpareModal.MaterialGroup': 'Material group',//物料组
    'ConfigureSpareModal.EndTime': 'End Time',//结束时间
    'ConfigureSpareModal.PurchasingChannels': 'Purchasing channels',//采购渠道

    //多根树表格翻译
    'TreeTable.materialCode': 'Material No.',//物料号
    'TreeTable.name': 'Spare Parts Name(CN)',//零件名称
    'TreeTable.nameEn': 'Spare Parts Name(EN)',//零件英文名称
    'TreeTable.amount': 'QTY',//数量
    'TreeTable.isProcurement': 'Sales Status',//采购状态
    // 变更记录
    'ConfigureChangeModal.title': 'Modification Record',//变更记录
    'ConfigureChangeModal.num': 'No.',//序号
    'ConfigureChangeModal.before': 'Original Spare Parts',//被替换件(变更前)
    'ConfigureChangeModal.bysparepCodes': 'Spare Parts No.',//备件编号
    'ConfigureChangeModal.byMaterialCodes': 'Material No.',//物料号
    'ConfigureChangeModal.bySparepName': 'Spare Parts Name',//备件名称
    'ConfigureChangeModal.createTime': 'Submit date',//变更维护日期
    'ConfigureChangeModal.bySpareCount': 'quantity',//被替换备件数量
    'ConfigureChangeModal.spareCount': 'quantity',//替换备件数量
    'ConfigureChangeModal.replaceType': 'Type',//类型
    'ConfigureChangeModal.oldNewStatus': 'Replace Type',//新旧状态
    'ConfigureChangeModal.firstVin': 'First use of VIN',//首台使用Vin
    'ConfigureChangeModal.factoryChangeTime': 'Base switching time',//基地切换时间
    'ConfigureChangeModal.after': 'Replacement',//替换件(变更后)
    'ConfigureChangeModal.sparepCodes': 'Spare Parts No.',//备件编号
    'ConfigureChangeModal.materialCodes': 'Material No.',//物料号
    'ConfigureChangeModal.sparepName': 'Spare Parts Name',//备件名称
    'ConfigureChangeModal.remark': 'Notes',//备注
    'ConfigureChangeModal.attachmentPath': 'Attachment',//附件
    'ConfigureChangeModal.download': 'Download',//下载附件
    'ConfigureChangeModal.processingStrategy': 'Change remarks',//变更备注

    // 查询结果
    'ConfigureSearch.massage': 'Please give search terms',//请输入搜索条件
    'ConfigureSearch.input': 'Spare Parts/Material No./Name',//编号/物料号/名称
    'ConfigureSearchModal.title': 'Result',//查询结果
    'ConfigureSearchModal.grade': 'No.',//标号
    'ConfigureSearchModal.sparepNo': 'Spare Parts No.',//备件编号
    'ConfigureSearchModal.materialCode': 'Material No.',//物料号
    'ConfigureSearchModal.sparepName': 'Spare Parts Name',//备件名称
    'ConfigureSearch.EnterName/sparePartNumber/partNumberQuery': 'Enter name/spare part number/part number query',//输入名称/备件号/零件号查询
    'ConfigureSearchModal.demand': 'Search',//查询

    //是否添加到购物车
    'ShoppingCart.isAddShoppingCart':'Are you sure to add this spare part to the shopping cart?',
    'ShoppingCart.Determine':'Determine',
    'ShoppingCart.cancel':'cancel',

    //断点信息
    'ConfigureBreakPointModal.title': 'Modification Nodes',//断点信息
    'ConfigureBreakPointModal.num': 'No.',//序号
    'ConfigureBreakPointModal.receptionVin': 'Initial Vin after modification',//变更后首台VIN码
    'ConfigureBreakPointModal.factoryCode': 'Factory',//工厂
    'ConfigureBreakPointModal.breakTime': 'Effective Time',//切换点时间
    'ConfigureBreakPointModal.factoryType': 'Suitable Market',//区域

    //购物车查询
    'shopping.demand': 'Search',                               //查询
    'shopping.reset': 'Reset',                                 //重置
    'shopping.spareNoInput': 'Spare Parts Number',  //备件编号
    'shopping.MATNRInput': 'Dongfeng part number',           //东风零件号
    'shopping.startTimeInput': 'Please Select End Time',     //请选择起始时间
    'shopping.DeadlineInput': 'Please Select Endtime',        //请选择截止时间

    //购物车表格
    'shopping.derive': 'Export', //导出
    'shopping.batchDelete': 'batch delete', //提交订单
    'shopping.tableNo': 'No.', //序号
    'shopping.tableSpareNo': 'Spare Parts No.', //备件编号
    'shopping.tableMATNR': 'Material No.', //物料号
    'shopping.tableSpareName': 'Spare Parts Name', //备件名称
    'shopping.tableServiceStation': 'Code of Retailer', //服务站代码
    'shopping.tableOrderTime': 'Ordering Time', //订购时间
    'shopping.addtableOrderTime': 'Adding Time', //添加时间
    'shopping.tableAmount': 'QTY', //数量
    'shopping.tableOperation': 'Operation', //操作
    'shopping.tableDelete': 'Delete', //删除
    'shopping.pushSpareParts': 'Push spare parts', //推送备件

    //备件所属车系查询
    'CarsSpareParts.spareNoInput':'Spare Parts Number',//备件编号
    'CarsSpareParts.MATNRInput':'Dongfeng part number',//东风零件号
    'CarsSpareParts.carseriesCode':'Vehicle system',//车系
    'CarsSpareParts.demand':'Search',//查询
    'CarsSpareParts.reset':'Reset',//重置

    'carsSpareParts.code': 'Spare Group Code',//备件分组号

    //备件所属车系表格
    'CarsSpareParts.tableNo':'No.',//序号
    'CarsSpareParts.tableSpareNo':'Spare Parts No.',//备件编号
    'CarsSpareParts.tableMATNR':'Dongfeng part number',//东风零件号
    'CarsSpareParts.tableSpareName':'Spare Parts Name',//备件名称
    'CarsSpareParts.tableAMG':'Car Model',//车系
    'CarsSpareParts.tableAnnual':'Year',//年款
    'CarsSpareParts.tableConfiguration':'Configuration',//配置
    'CarsSpareParts.tableEngineDisplacement':'Engine displacement',//发动机排量
    'CarsSpareParts.tableTransmission':'Transmission',//变速器
    'CarsSpareParts.tableColor':'Interior Trim Color',//内饰颜色
    'CarsSpareParts.tableDriveMode':'Drive Mode',//驱动方式
    'CarsSpareParts.tableVehicleMaterialNumber':'Vehicle Material Number',//整车物料号

    //备件变更查询
    'sparePartsChangeQuery.spareNoInput':'Spare Parts Number',//备件编号
    'sparePartsChangeQuery.MATNRInput':'Dongfeng part number',//东风零件号
    'sparePartsChangeQuery.demand':'Search',//查询
    'sparePartsChangeQuery.reset':'Reset',//重置

    //备件变更查询表格
    'sparePartsChangeQuery.tableNameOfNotice':'Name of Notice',//通知书名称
    'sparePartsChangeQuery.tableAudiName':'Name of Department of Vehicles',//车系名称
    'sparePartsChangeQuery.tableGroupNumber':'Group number',//分组号
    'sparePartsChangeQuery.tableChangeType':'Change type',//变更类型
    'sparePartsChangeQuery.tableChangeTime':'Change time',//变更时间
    'sparePartsChangeQuery.operate':'operate',//操作
    'sparePartsChangeQuery.tableSubstitutedMaterialNumber':'Substituted Material Number',//被替换件物料号
    'sparePartsChangeQuery.tableSubstitutedName':'Substituted name',//被替换件名称
    'sparePartsChangeQuery.tableNumber':'Number',//数量
    'sparePartsChangeQuery.tableReplacementMaterialNumber':'Replacement Material Number',//替换件物料号
    'sparePartsChangeQuery.tableSubstituteName':'Substitute name',//替换件名称

    //订单历史查询
    'orderHistory.ChineseName':'Chinese Name',//中文名称
    'orderHistory.demand':'Search',//查询
    'orderHistory.reset':'Reset',//重置

    //订单历史表格
    'orderHistory.tableNo':'No.',//序号
    'orderHistory.tableOrderNumber':'Order number',//订单号
    'orderHistory.tableOrderTimes':'Order time',//订单时间
    'orderHistory.tableOperation':'operation',//操作
    'orderHistory.tableResubmit':'Resubmit',//再次提交
    'orderHistory.tableSeeDetails':'See details',//查看详情
    'orderHistory.tableSpareNo':'Spare Parts Number',//备件编号
    'orderHistory.tableMATNR':'Dongfeng part number',//东风零号号
    'orderHistory.tableSpareName':'Part Name',//备件名称
    'orderHistory.tableSubmissionTime':'Submission time',//提交时间
    'orderHistory.tableOrderTime':'Order time',//订购时间
    'orderHistory.tableNumber':'Number',//数量
    'orderHistory.tableConfirm':'confirm',//确认
    'orderHistory.tableCancel':'cancel',//取消
    'orderHistory.tableSubmitAgain':'Are you sure you want to submit again?',//确定要再次提交吗?
    'orderHistory.chineseName':'Chinese name',//中文名称
    'orderHistory.SubmitSuccessfully':'Submit successfully',//提交成功

    //查询二轨件查询
    'ConfigureSpareModal.TwoTrackFittings': 'Two-track fittings',//二轨件
    'ConfigureSpareModal.OneTrackFittings': 'One-track fittings',//一轨件
    'ConfigureSpareModal.MaterialCoding': 'Material Coding',//东风零件号
    'ConfigureSpareModal.NameOfMaterial': 'Name of material',//物料名称
    'ConfigureSpareModal.Supplier': 'Supplier',//供应商
    'ConfigureSpareModal.SelectionOfCorrespondingRailComponents': 'Selection of corresponding rail components',//选择对应一轨件

    //车系查询store
    'ConfigureQuery.PleaseEnterVINCodeFirst':'Please enter VIN code first',//请先输入vin码
    'ConfigureQuery.VinCodeDoesNotExist':'Please use configuration query',//请用配置查询
    'ConfigureQuery.PleaseEnterTheSearchCriteria':'Please enter the search criteria',//请输入搜索条件
    'ConfigureQuery.carseriesCode':'Please select the car series',//请选择车系
    'ConfigureQuery.TwoTrackFittings':'Two-track fittings',//二轨件
    'ConfigureQuery.ThreeTrackFittings':'Three-track fittings',//三轨件
    'ConfigureQuery.FourTrackFittings':'Four-track fittings',//四轨件
    'ConfigureQuery.FiveTrackFittings':'Five-track fittings',//五轨件
    'ConfigureQuery.SixTrackFittings':'Six-track fittings',//六轨件
    'ConfigureQuery.SevenTrackFittings':'Six-track fittings',//七轨件
    'ConfigureQuery.EightTrackFittings':'Six-track fittings',//八轨件
    'ConfigureQuery.NineTrackFittings':'Six-track fittings',//九轨件
    'ConfigureQuery.Time':'Time',//时间
    'ConfigureQuery.success':'Push success！',//推送成功
    'ConfigureQuery.warning':'Push failure！',//推送失败
    'ConfigureQuery.PleaseCheckTheVinCodeInOverseasCarSeries':'This model does not support vin code query!',//该车型暂不支持vin码查询
    'ConfigureQuery.PleaseCheckTheVinCodeInTheDomesticCarSeries':'This model does not support vin code query!',//该车型暂不支持vin码查询
    'ConfigureQuery.noAuthor':'The brand is not authorized!', //未授权该品牌

    //精品目录
    'Boutique.index': 'Boutique catalogue'
}



// WEBPACK FOOTER //
// ./src/components/locales/en-US.message.js